import { Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import React, { Fragment } from 'react';
import Layout from './components/Layout/Layout';
import Login from './components/_pages/Login/Login';
import { AccountRoutes } from './components/_pages/ChangePassword/AccountRoutes';
import { DashboardRoutes } from './components/_pages/Dashboard/DashboardRoutes';
import { ScriptsRoutes } from './components/_pages/Scripts/ScriptsRoutes';
import { TeamsRoutes } from './components/_pages/Team/TeamsRoutes';
import { PatientsRoutes } from './components/_pages/Patients/PatientsRoutes';
import { RefillsRoutes } from './components/_pages/Refills/RefillsRoutes';
import { PhysiciansRoutes } from './components/_pages/Physicians/PhysiciansRoutes';
import { ProductsRoutes } from './components/_pages/Products/ProductsRoutes';
import { AgendaRoutes } from './components/_pages/Agenda/AgendaRoutes';
import { ReportsRouter } from './components/_pages/Reports/ReportsRouter';
import { HealthRouter } from './components/_pages/Health/HealthRouter';
import Analytics from './components/_pages/Analytics/Analytics';
import Chat from './components/_pages/Chat/Chat';
import { PossiblePersonsRoutes } from './components/_pages/PossiblePersons/PossiblePersonsRoutes';
import Oauth from './components/_pages/PossiblePersons/PossiblePersonsComponent/Oauth';

const routes = [AccountRoutes, DashboardRoutes, ScriptsRoutes, AgendaRoutes, PatientsRoutes,
  TeamsRoutes, ProductsRoutes, RefillsRoutes, PhysiciansRoutes, ReportsRouter, HealthRouter,
  // PossiblePersonsRoutes
];

const App = () => (
  <>
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route path="login" element={<Login />} />
        {/* <Route path="chat" element={<Chat />} /> */}
        {/* <Route path="analytics" element={<Analytics />} /> */}
        {/* <Route path="auth" element={<Oauth />} /> */}

        {routes.map((route, i) => (
          <Fragment key={i}>
            {route}
          </Fragment>
        ))}
      </Route>
    </Routes>

    <ToastContainer />
  </>
);

export default App;
